export const PAYMENT_GATEWAYS_ENDPOITNS = {
  GET_PAYMENT_GATEWAYS:
    'payment-methods/published/payment-method-providers/published',
} as const;
